<app-tab-toolbar [accessTabId]="'process'" [selectedYear]="selectedYear" [showSave]="isUserRole || isLeaderRole" [saveDisabled]="!hasChanges" (yearChange)="onYearChange($event)" (save)="onSave()">
  @if (showYearWarning) {
    <div class="year-warning">
      <mat-icon>warning</mat-icon>
      <span>There is no data for the selected year</span>
    </div>
  }
</app-tab-toolbar>

<div class="container" [formGroup]="form" [appReadOnlyTab]="'process'">
  <div class="sections-row">
    @for (domain of visibleDomains; track domain.key) {
      <section class="section-container nrg-border-radius-second-level">
        <div class="section-header">
          <span>{{ domain.label }}</span>
        </div>
        <div class="section-content">
          @if (!isUserRole && !isLeaderRole) {
            <div class="process-item">
              <span class="type-badge" [class.status-true]="form.get(domain.checkedField)?.value" [class.status-false]="!form.get(domain.checkedField)?.value">Checked</span>
              <span class="process-detail">{{ formatDate(form.get(domain.checkedDateField)?.value) }}</span>
              <span class="process-detail process-user">{{ userNames[domain.checkedByNameField] || '&nbsp;' }}</span>
            </div>
            <div class="process-item">
              <span class="type-badge" [class.status-true]="form.get(domain.finishedField)?.value" [class.status-false]="!form.get(domain.finishedField)?.value">Finished</span>
              <span class="process-detail">{{ formatDate(form.get(domain.finishedDateField)?.value) }}</span>
              <span class="process-detail process-user">{{ userNames[domain.finishedByNameField] || '&nbsp;' }}</span>
            </div>
          } @else {
            @if (isLeaderRole) {
              <div class="process-toggle">
                <mat-slide-toggle [formControlName]="domain.checkedField"></mat-slide-toggle>
                <span class="toggle-label">Checked</span>
              </div>
              @if (form.get(domain.checkedField)?.value && form.get(domain.checkedDateField)?.value) {
                <span class="process-detail">{{ formatDate(form.get(domain.checkedDateField)?.value) }}</span>
                <span class="process-detail process-user">{{ userNames[domain.checkedByNameField] || '&nbsp;' }}</span>
              }
            }
            <div class="process-toggle">
              <mat-slide-toggle [formControlName]="domain.finishedField"></mat-slide-toggle>
              <span class="toggle-label">Finished</span>
            </div>
            @if (form.get(domain.finishedField)?.value && form.get(domain.finishedDateField)?.value) {
              <span class="process-detail">{{ formatDate(form.get(domain.finishedDateField)?.value) }}</span>
              <span class="process-detail process-user">{{ userNames[domain.finishedByNameField] || '&nbsp;' }}</span>
            }
          }
        </div>
      </section>
    }
  </div>
</div>
